// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import SelectContractor from '../layout/SelectContractor';
import Notification from '../notification';
import { dashboardSelectClassNames } from '../../utils/customSelectStyle';

import { sendInviteFromWorkOrderToContractor } from '../../storage/actions/workOrdersActions';
import { toggleModal } from '../../storage/actions/modalsActions';
import prepareFilters from '../../utils/prepareFilters';
import { getStatus } from '../../utils/api/get/getWorkOrders';

const BulkWorkOrderRouteContractorModal = ({
  modalState,
  selectedWorkOrders,
  toggleModal,
  sendInviteFromWorkOrderToContractor,
  search,
  filters,
  activeTab,
}) => {
  const [selectedContractor, setSelectedContractor] = useState();
  const [requestData, setRequestData] = useState({});

  useEffect(() => {
    const newRequestData = modalState?.type?.mode === 'useFilters'
      ? {
        ...search,
        filters: prepareFilters(filters),
      }
      : { workOrdersId: selectedWorkOrders };
    setRequestData({ ...newRequestData, ...getStatus(activeTab) });
  }, [modalState?.type?.mode]);

  const closeModal = () => {
    toggleModal(false, 'bulkWorkOrderRouteContractorModal');
  };

  const handlerSubmit = (event) => {
    event.preventDefault();
    if (!selectedContractor?.value?.userId) {
      Notification('warning', { message: 'Please select contractor!' });
    } else {
      sendInviteFromWorkOrderToContractor({
        ...requestData,
        contractorId: selectedContractor.value.userId,
      });
    }
  };

  if (!modalState.isOpen) return null;

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="modal_container"
        style={{ minHeight: 'fit-content' }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="route-contractor-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title" id="route-contractor-title">
            Route Contractor
          </div>
          <button
            type="button"
            className="close_btn icon_close"
            aria-label="close"
            onClick={closeModal}
          />
        </div>
        <div className="modal_body">
          <div className="field_row">
            <div className="field_block dashboard-select-wrap">
              <SelectContractor
                selectedContractor={selectedContractor}
                getSelectedContractor={setSelectedContractor}
                placeholder="Enter 3 or more letters to search contractors!"
                dashboardStyle
                selectClassNames={dashboardSelectClassNames}
              />
            </div>
          </div>
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="standard_btn dark_btn"
            aria-label="route"
            onClick={handlerSubmit}
          >
            Route
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  sendInviteFromWorkOrderToContractor,
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.bulkWorkOrderRouteContractorModal,
  filters: state.workOrder?.filters,
  search: state.workOrder?.searchData,
  activeTab: state.applicationState.activeTab,
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkWorkOrderRouteContractorModal);
